import axios from 'axios';
import { authInterceptor, logout } from './auth-interceptor';

// The Interview Intelligence service — a separate backend from core's `/api/v1`. It serves the
// Live Coach REST surface (`/sessions/:id/coach/ask`, `/sessions/:id/coach/events`) over Bearer JWT,
// and a WebSocket for the realtime nudge stream (see `useInterviewIntelligenceWS`). Same auth
// interceptor as the other off-core clients (agentforge, voice-agent), so token refresh / logout
// behave identically. In dev the URL points at the interview-intelligence service directly; if the env var is unset we
// fall back to same-origin so a Caddy/Vite proxy can stand in.
const interviewIntelligenceUrl = import.meta.env
  .VITE_INTERVIEW_INTELLIGENCE_URL;
const apiVersion = '/api/v1';

export const interviewIntelligenceHttp = axios.create({
  baseURL: interviewIntelligenceUrl
    ? `${interviewIntelligenceUrl}${apiVersion}`
    : `${apiVersion}`,
  withCredentials: true,
});

interviewIntelligenceHttp.interceptors.response.use((result) => result.data);

authInterceptor(interviewIntelligenceHttp, {
  getAccessToken: () => localStorage.getItem('apiv1Auth'),

  shouldLogout: (error) => {
    const { response: { data = {} } = {} } = error;
    return ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some(
      (err) => data?.errors?.includes?.(err)
    );
  },

  shouldRefresh: (error) => {
    const { response: { status, data = {} } = {} } = error;
    if (
      status === 401 &&
      (data?.code === 401 || data?.error === 'Unauthorized')
    ) {
      return true;
    }
    return data?.errors?.includes?.('err_token_expired');
  },

  logout,
});

export default interviewIntelligenceHttp;
